<footer>
  <div class="footer-logo"><img src="./assets/images/icons/logo-kpmg-light.svg" alt="KPMG LOGO" /></div>
  <div class="footer-content">
    <div>
      © {{ copyrightYear }} {{ copyright }}
    </div>
    <div class="action-buttons"></div>
  </div>
</footer>
